import React from 'react';
import { SvgIcon } from '@material-ui/core';

const MessagesIcon = (props) => {
  return (
      <img class="homeicon" viewBox="0 0 24 24" src="./images/messages.svg" alt="" />
  );
};

export default MessagesIcon;
